import { HugeiconsIcon } from "@hugeicons/react";
import { Tick01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Card } from "shared/components/Card";
import { ReactNode } from "react";
import type { IconSvgElement } from "@hugeicons/react";

interface ActionSuccessCardProps {
  icon: IconSvgElement;
  title: string;
  children?: ReactNode;
  iconSize?: number;
  className?: string;
}

export const ActionSuccessCard = ({
  icon,
  title,
  children,
  iconSize = 32,
  className = "px-6"
}: ActionSuccessCardProps) => {
  return (
    <Card className={className}>
      <div className="py-6 pb-4 border-b border-alpha-40">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <HugeiconsIcon
              icon={icon}
              size={iconSize}
              className="text-content-200 shrink-0"
            />
            <p className="text-base font-medium text-content-1000">{title}</p>
          </div>
          <HugeiconsIcon
            icon={Tick01Icon}
            size={20}
            className="text-success-600 shrink-0"
          />
        </div>
      </div>
      {children ? <div className="py-6">{children}</div> : null}
    </Card>
  );
};
